import React, { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import SnackbarAlert from "../../components/SnackbarAlert";
import { Box, Button, TextField, IconButton, Tooltip, Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../../constants/globalConstants';
import { makeRequest } from "../../services/api";
import noImage from "../../assets/noimage.png";
import CloseIcon from "@mui/icons-material/Close";
export default function PlanCategoryMaster() {
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [editState, setEditState] = useState(null);
    const [categoryName, setCategoryName] = useState();
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    useEffect(() => {
        fetchMainCategory();
    }, []);
    const fetchMainCategory = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "maincategories";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditState(null);
        setCategoryName("");
        setPreview("");
        setOpenModal(true);
    };
    const handleEdit = (data) => {
        setEditState(data);
        setCategoryName(data.maincategory_name);
        setPreview(data.image_url);
        setOpenModal(true);
    };
    const handleSave = async () => {
        if (!categoryName.trim() && !preview) {
            setMessage("Main Category Name and Image are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const categoryEditData = {
                    maincategory_name: categoryName,
                    image_url: image ? image : preview
                };
                try {
                    let url = webEndPoint + "maincategories/" + editState.rfId;
                    const response = await makeRequest("put", url, categoryEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Main Category Updated Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                const categoryAddData = {
                    maincategory_name: categoryName,
                    image_url: image
                };
                try {
                    let url = webEndPoint + "maincategories";
                    const response = await makeRequest("post", url, categoryAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Main Category Added Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            setDataSource([]);
            fetchMainCategory();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
            const formData = new FormData();
            formData.append('file', file);
            try {
                setLoading(true);
                const response = await fetch(webEndPoint + 'upload', {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.text();
                setImage(data);
                setLoading(false);
            } catch (error) {
                setMessage('Error during file upload:');
                setSnackbar(true);
                setLoading(false);
            }
        }
    };
    const handleClose = () => {
        setOpenModal(false);
    };
    const filtereddataSource = dataSource?.filter((d) =>
        d?.maincategory_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const handlePreview = (img) => {
        setPreviewImage(img);
        setPreviewOpen(true);
    };
    const handleClosePreview = () => {
        setPreviewOpen(false);
        setPreviewImage(null);
    };
    const columns = ["S.No", "Category Name", "Image", "Action"];
    const rows = filtereddataSource.map((data, index) => [index + 1, data?.maincategory_name,
    <Box component="img" src={data?.image_url || noImage} alt="category" onClick={() => handlePreview(data?.image_url || noImage)} sx={{ width: 50, height: 50, objectFit: "cover", borderRadius: 1, border: "1px solid #ddd", cursor: "pointer", transition: "0.3s" }} onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"} onMouseOut={e => e.currentTarget.style.transform = "scale(1)"} />,
    <Box>
        <Tooltip title="Edit Main Category">
            <IconButton color="primary" onClick={() => handleEdit(data)}><EditIcon /></IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Main Category Master</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Main Category" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add Main Category</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Main Category" : "Add Main Category"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField label="Main Category Name" value={categoryName} onChange={(e) => setCategoryName(e.target.value)} sx={{ mt: 2 }} fullWidth />
                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Image </Typography>
                        <Button variant="contained" component="label"> Choose File
                            <input type="file" accept="image/*" hidden onChange={handleImageChange} />
                        </Button>
                        {preview && (
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="caption">Preview:</Typography>
                                <Box component="img" src={preview} alt="preview" sx={{ width: 100, height: 100, objectFit: "cover", mt: 1, borderRadius: 1 }} />
                            </Box>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={previewOpen} onClose={handleClosePreview} maxWidth="md">
                <DialogTitle>
                    Image Preview
                    <IconButton onClick={handleClosePreview} sx={{ position: "absolute", right: 10, top: 10 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <img src={previewImage} alt="Preview" style={{ width: "100%", borderRadius: 10 }} />
                </DialogContent>
            </Dialog>
        </Box>
    );
}